import { render, staticRenderFns } from "./TransferOfEquityPersonEditor.vue?vue&type=template&id=77f7611a&"
import script from "./TransferOfEquityPersonEditor.vue?vue&type=script&lang=js&"
export * from "./TransferOfEquityPersonEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports